module.exports = __webpack_public_path__ + "static/media/close.9ed63920.svg";